import React, { useState } from "react";

import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  TextField,
  InputAdornment,
  MenuItem,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { BlockStandard } from "components/admin/BlockStandard";
import { SolutionsFrame } from "components/solutions/SolutionsFrame";

export const NoInvoicesCredentials = () => {
  const [showForm, setShowForm] = useState(false);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [distribuidora, setDistribuidora] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const distribuidoras = ["Light", "Enel", "CPFL"];

  const handleSave = (e) => {
    e.preventDefault();

    alert("Dados salvos!");
  };

  return (
    <SolutionsFrame title="Faturamento">
      <BlockStandard hideDivider>
        <img
          src="/static/img/no-invoices.png"
          alt=""
          style={{ height: "150px", objectFit: "contain" }}
        />
        <Typography align="center" variant="h3">
          OPS!
        </Typography>
        <Typography variant="body1">
          Para acessar os dados das suas faturas no app Enermatch é só inserir
          os dados de acesso da sua distribuidora de energia
        </Typography>
        {!showForm && (
          <Button
            variant="contained"
            fullWidth
            onClick={() => setShowForm(true)}
            sx={{ mt: 2 }}
          >
            Inserir dados da distribuidora
          </Button>
        )}
      </BlockStandard>

      <BlockStandard hideDivider>
        <Grid container>
          {showForm && (
            <Card
              sx={{
                p: 2,
                borderRadius: 4,
                boxShadow: 3,
                maxWidth: 350,
                mx: "auto",
              }}
            >
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                  Dados da distribuidora
                </Typography>
                <form onSubmit={handleSave}>
                  <TextField
                    select
                    label="Distribuidora de energia"
                    value={distribuidora}
                    onChange={(e) => setDistribuidora(e.target.value)}
                    fullWidth
                    required
                    sx={{ mb: 2, borderRadius: 2 }}
                  >
                    <MenuItem value="" disabled>
                      Distribuidora de energia
                    </MenuItem>
                    {distribuidoras.map((opt) => (
                      <MenuItem key={opt} value={opt}>
                        {opt}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    label="Seu login"
                    placeholder="demo@enermatch.com"
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                    fullWidth
                    required
                    sx={{ mb: 2, borderRadius: 2 }}
                  />
                  <TextField
                    label="Senha de acesso"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    fullWidth
                    required
                    sx={{ mb: 2, borderRadius: 2 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword((v) => !v)}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button type="submit" variant="contained" fullWidth>
                    Salvar e continuar
                  </Button>
                </form>
              </CardContent>
            </Card>
          )}
        </Grid>
      </BlockStandard>
    </SolutionsFrame>
  );
};

export default NoInvoicesCredentials;
